import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import {
  reviewTypeNames,
  reviewTypeLabels,
} from 'donor-elf-web/lib/review-item-utils';
import ReviewItemModel from 'donor-elf-web/models/review-item';

interface ComponentArgs {
  reviewItem: ReviewItemModel;
  classToApplyOnSave?: string;
  onSave: (reviewItem: ReviewItemModel) => void;
}

export default class ReviewItemCardIndexComponent extends Component<ComponentArgs> {
  @tracked saved = false;

  @action
  handleSave(reviewItem: ReviewItemModel) {
    this.saved = true;
    this.args.onSave(reviewItem);
  }

  get reviewTypeName() {
    return reviewTypeNames[this.args.reviewItem.reviewTypeId];
  }

  get reviewTypeLabel() {
    return reviewTypeLabels[this.args.reviewItem.reviewTypeId];
  }
}
